import { KpiTile } from './KpiTile'
import { formatDuration, formatInteger, formatPercent } from './formatters'
import { slaTier, tierText } from './slaHealth'
import type { KpisPanel } from '@/types/analytics'

interface KpiRowProps {
  data: KpisPanel
  rangeLabel: string
}

export function KpiRow({ data, rangeLabel }: KpiRowProps) {
  return (
    <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-6 gap-3">
      <KpiTile
        label="Conversations"
        value={formatInteger(data.conversations.value)}
        delta={data.conversations.delta}
        hint={`vs previous ${rangeLabel.toLowerCase()}`}
      />
      <KpiTile
        label="Median first reply"
        value={formatDuration(data.median_first_reply_seconds.value)}
        delta={data.median_first_reply_seconds.delta}
        invertDelta
        hint="across all replies"
        valueClassName={tierText[slaTier(data.median_first_reply_seconds.value, data.sla_seconds)]}
      />
      <KpiTile
        label="Median resolution"
        value={formatDuration(data.median_resolution_seconds.value)}
        delta={data.median_resolution_seconds.delta}
        invertDelta
        hint="open → resolved"
      />
      <KpiTile
        label="Resolution rate"
        value={formatPercent(data.resolution_rate.value)}
        delta={data.resolution_rate.delta}
        hint="of new conversations"
      />
      <KpiTile
        label="CSAT"
        value={data.csat.value != null ? `${data.csat.value.toFixed(1)} ★` : '—'}
        delta={data.csat.delta}
        hint="avg rating (1–5)"
      />
      <KpiTile
        label="Active visitors"
        value={formatInteger(data.active_visitors.value)}
        hint="on site right now"
      />
    </div>
  )
}
